import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import PaymentGatewayConfig from './PaymentGatewayConfig';
import { restrictUrls } from '../../../helpers/adminPrivileges';
import messages from '../../../locale/jsonMessages';

export default async function action({ store, params, intl }) {
    const isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
    const adminPrivileges = store.getState().account.privileges?.privileges;
    const privileges = store.getState().listSettings?.privileges;
    const gateway = params?.gateway;
    if (!isAdminAuthenticated) return { redirect: '/siteadmin/login' };
    if (!['paypal', 'stripe', 'pawapay'].includes(gateway)) return { redirect: '/siteadmin/payment-gateway-section' };
    if (!restrictUrls('/siteadmin/payment-gateway-section', adminPrivileges, privileges)) return { redirect: '/siteadmin' };
    const title = intl?.formatMessage(messages.managePaymentGateWay);
    return {
        title,
        component: <AdminLayout><PaymentGatewayConfig gateway={gateway} /></AdminLayout>
    };
}
